export const WAITLIST_SMS_VENDOR_TERMS_URL = 'https://attnl.tv/t/mUb/b7X'
export const WAITLIST_SMS_VENDOR_PRIVACY_URL = 'https://attnl.tv/p/mUb'
export const WAITLIST_SMS_VENDOR_TERMS_URL_UK = 'https://www.quince.com/uk/terms'
export const WAITLIST_SMS_VENDOR_PRIVACY_URL_UK = 'https://www.quince.com/uk/privacy-policy'
export const WAITLIST_SMS_PHONE_PLACEHOLDER = '(555) 000-0000'
